import React from 'react';
import PropTypes from 'prop-types';

// Links in the new Hero module for redirecting
const HeroLink = function (props) {
  const { type, link, target, message } = props;

  if (type && link) {
    return (
      <div className={`${type}-link`}>
        <a
          className={`${type}-text`}
          target={target}
          href={link}
          aria-label={message.full}
          onClick={() => props.clickHandler(type)}
        >
          <span id={`test_id_herolink_message_full-${type}`} className="hero-text hero-text__full">
            {message.full}
          </span>
          <span id={`test_id_herolink_message_short-${type}`} className="hero-text hero-text__short">
            {message.short}
          </span>
          <div className="popup-icon" aria-hidden="true" />
        </a>
      </div>
    );
  }
  return null;
};

HeroLink.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.shape({
    full: PropTypes.string,
    short: PropTypes.string,
  }),
  link: PropTypes.string,
  clickHandler: PropTypes.func,
  target: PropTypes.string,
};

HeroLink.defaultProps = {
  message: {
    full: '',
    short: '',
  },
  link: '',
  clickHandler: () => {},
  target: '_blank',
};
export default HeroLink;
